import { Project } from "@/interfaces/project.interface";
import { ApiQueryParams, apiRequest } from "../Api";

export interface UpdateProjectResponse {
  success: boolean;
  message: string;
  data: {id: string};
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export const updateProject = (
  projectId: string,
  params: ApiQueryParams,
  data: Partial<Project>
) =>
  apiRequest<Partial<Project>, UpdateProjectResponse>({
    url: `/entities/update/${projectId}`,
    scope: 'project',
    method: 'PUT',
    params,
    data: { data },
  });